var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgConstructionPaper = function SvgConstructionPaper(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 606.27 613.33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f4abe0",
    d: "M100.91 425.05l-26.57 15.18L338.31 600l201.45-114.62-27.28-15.74-174.17 99.1-237.4-143.69z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef6ba0",
    d: "M338.31 537.48l-237.4-143.69-26.57 15.18 26.57 16.08 237.4 143.69 174.17-99.1 27.28-15.52-27.28-15.74-174.17 99.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0592b",
    d: "M338.31 506.22l-237.4-143.69-26.57 15.18 26.57 16.08 237.4 143.69 174.17-99.1 27.28-15.52-27.28-15.73-174.17 99.09z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6842d",
    d: "M338.31 474.96l-237.4-143.69-26.57 15.18 26.57 16.08 237.4 143.69 174.17-99.09 27.28-15.53-27.28-15.73-174.17 99.09z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdb73e",
    d: "M338.31 443.7l-237.4-143.69-26.57 15.18 26.57 16.08 237.4 143.69 174.17-99.09 27.28-15.52-27.28-15.74-174.17 99.09z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#93b847",
    d: "M338.31 412.44l-237.4-143.69-26.57 15.18 26.57 16.08 237.4 143.69 174.17-99.09 27.28-15.52-27.28-15.74-174.17 99.09z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ab4e5",
    d: "M338.31 381.19l-237.4-143.7-26.57 15.18 26.57 16.08 237.4 143.69 174.17-99.09 27.28-15.52-27.28-15.74-174.17 99.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#015e85",
    opacity: 0.89,
    d: "M100.91 206.24l-26.57 15.17 26.57 16.08 26.56-15.18-26.56-16.07zM512.48 282.09l27.28-15.52-27.28-15.74-27.28 15.52 27.28 15.74z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ab4e5",
    d: "M338.31 349.93L127.47 222.31l-26.56 15.18 237.4 143.7 174.17-99.1-27.28-15.74-146.89 83.58z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#015e85",
    opacity: 0.89,
    d: "M338.31 349.93L127.47 222.31l-26.56 15.18 237.4 143.7 174.17-99.1-27.28-15.74-146.89 83.58z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e5f91",
    d: "M338.31 318.67l-237.4-143.7-26.57 15.19 26.57 16.08 26.56 16.07 210.84 127.62 146.89-83.58 27.28-15.52 27.28-15.52-27.28-15.74-174.17 99.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef6ba0",
    d: "M338.31 287.41l-237.4-143.69-26.57 15.18 26.57 16.07 237.4 143.7 174.17-99.1 27.28-15.52-27.28-15.74-174.17 99.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4abe0",
    d: "M268.84 16.49L74.34 127.64l26.57 16.08 237.4 143.69 174.17-99.1 27.28-15.52-270.92-156.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M579 76.84c-2 0-20-.67-20-21.67a2.17 2.17 0 0 0-4.33 0c0 21-18 21.67-20 21.67h-.17a2.16 2.16 0 0 0-2 2.16 2.21 2.21 0 0 0 2.17 2.17c2.16 0 20 .66 20 21.66a2.21 2.21 0 0 0 2.17 2.16 1.92 1.92 0 0 0 2-2c0-21 18-21.66 20-21.66h.16a2.24 2.24 0 0 0 2.19-2.33 2.2 2.2 0 0 0-2.19-2.16z",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConstructionPaper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/construction_paper.67fa08cb.svg";
export { ForwardRef as ReactComponent };